export const COGNITO_BASEURL = "https://cognito-idp.us-east-2.amazonaws.com/";
// export const API_BASEURL = 'http://dev-stavc-webapi-env.eba-3dctvedt.us-east-2.elasticbeanstalk.com/api/';
export const API_BASEURL = `${process.env.REACT_APP_API_BASE_URL}`;
export const CONTENT_V1 = "v1/videoIndex/";
export const LABELDETECTION_V1 = "v1/labeldetection/";
